import React, { useCallback, useEffect, useMemo, useRef } from 'react'
// import { selectAuthCommunication } from 'features/auth/selectors'
import { useAppDispatch } from 'index'

import { getUserPromotionsPoll } from 'features/bonusSystem/actions'

const PromotionsPolling: React.FC = () => {
  const dispatch = useAppDispatch()
  // eslint-disable-next-line no-undef
  const currentTimeoutId = useRef<NodeJS.Timeout>()
  // eslint-disable-next-line no-undef
  const previousTimeoutId = useRef<number>()

  const getTimeoutedFunc = useMemo(
    () => () => {
      currentTimeoutId.current = setTimeout(() => {
        previousTimeoutId.current = Number(currentTimeoutId.current)
        dispatch(getUserPromotionsPoll()).then(() => {
          if (previousTimeoutId.current === currentTimeoutId.current) getTimeoutedFunc()
        })
      }, 20 * 1000)
    },
    [dispatch],
  )

  const getUserPromotionsFunc = useCallback(() => {
    getTimeoutedFunc()
    dispatch(getUserPromotionsPoll())
  }, [getTimeoutedFunc])

  useEffect(() => {
    if (currentTimeoutId.current) {
      clearTimeout(currentTimeoutId.current)
      previousTimeoutId.current = 0
    }
    getUserPromotionsFunc()
    return () => {
      if (currentTimeoutId.current) {
        clearTimeout(currentTimeoutId.current)
        previousTimeoutId.current = 0
      }
    }
  }, [])
  return null
}

export default PromotionsPolling
